import React, { useRef } from "react";
import { DeleteButton } from "../../common/components/DeleteButton";
import { ImpiantoClimaDto } from "../../generated";
import InterventiStore from "../../interventi/interventiStore";
import impiantiActions from "../ImpiantiClimaActions";
import OpenModalButton from "../../common/components/openModalButton";

export default (props: { impianto: ImpiantoClimaDto }) => {
    const { impianto } = props;
    const modal = useRef<OpenModalButton>(null);
    const interventi = InterventiStore.useForCliente(impianto.idCliente);
    if (interventi == null) return null;

    const interventiImpianto = interventi.filter(x => x.idImpianto == impianto.id);
    if (interventiImpianto.length == 0)
        return <DeleteButton
            onDelete={() => impiantiActions.delete(impianto.idCliente, impianto.id)}
            message="Sei sicuro di voler eliminare l'impianto?"
        />


    return <OpenModalButton
        ref={modal}
        className="btn btn-danger"
        modalContent={<CancelImpiantoPreview
            impianto={impianto}
            onComplete={() => modal?.current?.close()} />
        }>
        <i className="fas fa-trash" />  Dismetti
    </OpenModalButton>

}


const CancelImpiantoPreview = (props: { impianto: ImpiantoClimaDto, onComplete: () => void }) => {
    const { impianto, onComplete } = props;
    return <div className="d-flex justify-content-between p-3">
        <div className="card m-2">
            <div className="card-body">
                <h2 className="fw-bold">Dismissione impianto</h2>
                <p>L'impianto verrà marcato come dismesso e non cancellato</p>
                <div>Tutto lo storico interventi, bollini rimane in anagrafica ed è possibile anche ripristinarlo</div>
            </div>
            <div className="card-footer">
                <button
                    type="button"
                    className="btn btn-warning w-100"
                    onClick={async () => {
                        impianto.dismesso = true;
                        await impiantiActions.update(impianto, impianto.id)
                        onComplete();
                    }}>
                    Dismetti Impianto
                </button>
            </div>
        </div>
        <div className="card m-2">
            <div className="card-body">
                <h2 className="fw-bold">Eliminazione impianto</h2>
                <p>L'impianto verrà eliminato definitivamente.</p>
                <div>Con esso verranno eliminati anche gli interventi,bollini e contratti collegati ad esso</div>
            </div>
            <div className="card-footer">
                <button
                    type="button"
                    className="btn btn-danger w-100"
                    onClick={async () => {
                        await impiantiActions.delete(impianto.idCliente, impianto.id)
                        onComplete();
                    }}>
                    Elimina Impianto
                </button>
            </div>

        </div>
    </div >
}